import { Box, Stack, Typography } from "@mui/joy";
import { Story } from "../stories.data";

const RING_SIZE = 72;
const RING_WIDTH = 2.5;

export default function StoriesBarView({
  stories,
  seenIds,
  onOpen,
}: {
  stories: Story[];
  seenIds: string[];
  onOpen: (index: number) => void;
}) {
  return (
    <Stack
      direction="row"
      gap={2}
      sx={{
        // выходим за padding страницы, чтобы лента скроллилась «под край»
        mx: -2,
        px: 2,
        overflowX: "auto",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": { display: "none" },
      }}
    >
      {stories.map((story, index) => {
        const seen = seenIds.includes(story.id);

        return (
          <Stack
            key={story.id}
            alignItems="center"
            gap={0.5}
            onClick={() => onOpen(index)}
            sx={{ cursor: "pointer", flexShrink: 0, width: RING_SIZE + 12, "&:active": { transform: "scale(0.95)" } }}
          >
            <Box
              sx={{
                width: RING_SIZE,
                height: RING_SIZE,
                borderRadius: "50%",
                p: `${RING_WIDTH}px`,
                background: seen
                  ? "var(--joy-palette-neutral-300, #cdd7e1)"
                  : "linear-gradient(135deg, #D9347E 0%, #F0872A 100%)",
              }}
            >
              <Box
                component="img"
                src={story.cover}
                alt={story.title}
                loading="lazy"
                sx={{
                  width: "100%",
                  height: "100%",
                  borderRadius: "50%",
                  objectFit: "cover",
                  display: "block",
                  border: "2px solid var(--joy-palette-background-body, #fff)",
                  boxSizing: "border-box",
                }}
              />
            </Box>

            <Typography
              level="body-xs"
              textAlign="center"
              sx={{
                width: "100%",
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: 2,
                overflow: "hidden",
                lineHeight: 1.2,
                color: seen ? "neutral.400" : "text.primary",
              }}
            >
              {story.title}
            </Typography>
          </Stack>
        );
      })}
    </Stack>
  );
}
